module.exports = __webpack_public_path__ + "img/terms-img.e94eec21.png";